import { fabric } from 'fabric';
import { CanvasDataTypes } from '../../../../utils';

const IMAGE_TYPED_DATA_TYPES: ReadonlyArray<string> = [
  CanvasDataTypes.PhotoZoneImage,
  CanvasDataTypes.UserImage,
  CanvasDataTypes.WamImage,
];

/**
 * Returns `true` when the provided fabric object represents an image that
 * the desktop image edit toolbar can operate on (a raw image, a user image,
 * a photo-zone image, or a handwriting image).
 */
export const isImageLikeObject = (obj?: fabric.Object | null): boolean => {
  if (!obj) {
    return false;
  }

  if (obj.type === 'image') {
    return true;
  }

  const dataType = obj.data?.type;
  return typeof dataType === 'string' && IMAGE_TYPED_DATA_TYPES.includes(dataType);
};
